import { ArrowBack } from '@mui/icons-material'
import { Button, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.5rem',
    margin: '0.875rem 0',

    '& h1': {
      color: '#191C1A',
      fontFamily: 'Sora',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2rem',
      margin: 0,
      padding: 0,
    },
  },

  actionBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  actionbutton: {
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.primary.main,
    height: '2.5rem',
    paddingY: '0.375rem !important',
    paddingX: '1rem !important',
  },

  icon: {
    cursor: 'pointer',
  },
}))

interface HeaderModuleTitleProps {
  text: string
  backRoute?: string
  actionRoute?: string
  actionText?: string
  isActionDisabled?: boolean
}

const HeaderModuleTitle = ({ text, backRoute, actionRoute, isActionDisabled, actionText }: HeaderModuleTitleProps) => {
  const classes = useStyles()
  const history = useHistory()

  const handleBack = () => history.push(backRoute || '/')
  const handleAction = () => history.push(actionRoute || '/')

  return (
    <div className={classes.actionBox}>
      <div className={classes.root}>
        {backRoute && (
          <ArrowBack
            className={classes.icon}
            onClick={handleBack}
          />
        )}
        <h1 className={classes.root}>{text}</h1>
      </div>

      {actionRoute && (
        <Button
          variant='contained'
          className={classes.actionbutton}
          disabled={isActionDisabled}
          onClick={handleAction}
        >
          {actionText}
        </Button>
      )}
    </div>
  )
}

export default HeaderModuleTitle
